import {Component, Input} from '@angular/core';
import {VorhersageTag} from '../../../../../../../../model/vorhersagen/vorhersage-zehn-tage';
import {DatastoreService} from '../../../../../../../../service/datastore/datastore.service';
import {WerteConverterUtil} from '../../../../../../../../util/werte-converter-util';

@Component({
  selector: 'app-24h-vorhersage-table-detail',
  templateUrl: './vierundzwanzig-stunden-vorhersage-table-detail.component.html',
  styleUrls: ['../../../vorhersagen-table-styles.css']
})
export class VierundzwanzigStundenVorhersageTableDetailComponent {

  @Input() element: VorhersageTag;

  constructor(public datastoreService: DatastoreService, public werteConverter: WerteConverterUtil) {
  }

}
